export default __webpack_public_path__ + "assets/audios/eca7111442f24e533174d2c33f4a905b.mp3";